<!--CART DRAWLER DISCOUNT WIDGET START-->

  document.addEventListener("DOMContentLoaded", function () {
    function renderWidget() {
      const container = document.getElementById("discount-progress-container");
      if (!container) return;

      // If widget already exists, don’t duplicate
      if (document.getElementById("discount-progress-widget")) return;

      container.innerHTML = `
        <div id="discount-progress-widget">
          <p id="discount-message">Loading discount info...</p>
          <div class="progress-wrapper">
            <div class="progress-bar">
              <div class="progress-fill"></div>
            </div>
            <div class="progress-points">
              <span>0%</span>
              <span>5%</span>
              <span>10%</span>
              <span>15%</span>
            </div>
          </div>
        </div>
      `;
    }

    function updateDiscountProgress(totalQty) {
      const messageEl = document.getElementById("discount-message");
      const progressFill = document.querySelector(".progress-fill");
      if (!messageEl || !progressFill) return;

      let discount = 0;
      let nextTarget = 0;
      let message = "";

      if (totalQty < 2) {
        discount = 0;
        nextTarget = 2 - totalQty;
        message = `Add ${nextTarget} more item${nextTarget > 1 ? "s" : ""} to unlock <b>5%</b> discount`;
      } else if (totalQty < 3) {
        discount = 5;
        nextTarget = 3 - totalQty;
        message = `Add ${nextTarget} more item to unlock <b>10%</b> discount`;
      } else if (totalQty < 4) {
        discount = 10;
        nextTarget = 4 - totalQty;
        message = `Add ${nextTarget} more item to unlock <b>15%</b> discount`;
      } else {
        discount = 15;
        message = `🎉 You unlocked <b>15%</b> discount!`;
      }

      let width = (discount / 15) * 100;
      progressFill.style.width = width + "%";

      if (discount === 0) progressFill.style.background = "#ff9800";
      if (discount === 5) progressFill.style.background = "#8AC68A";
      if (discount === 10) progressFill.style.background = "#56C256";
      if (discount === 15) progressFill.style.background = "#008100";

      messageEl.innerHTML = message;
    }

    function refreshWidget() {
      renderWidget();
      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
          // Count only NON-subscription items
          let totalQty = cart.items.reduce((sum, item) => {
            // Recharge marks subscriptions with selling_plan_allocation or properties
            const isSubscription =
              (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) ||
              (item.properties && (
                item.properties.shipping_interval_frequency ||
                item.properties.shipping_interval_unit_type
              ));

            return isSubscription ? sum : sum + item.quantity;
          }, 0);

          const widget = document.getElementById("discount-progress-widget");
          if (!widget) return;

          if (totalQty === 0) {
            widget.style.display = "none";
          } else {
            widget.style.display = "block";
            updateDiscountProgress(totalQty);
          }
        });
    }


    // Initial load
    refreshWidget();

    // Re-run whenever cart updates
    document.addEventListener("cart:updated", refreshWidget);
  });

<!--CART DRAWLER DISCOUNT WIDGET END-->